import { ClockingUserDTO, Res } from 'core/api';
import getPassword from './getPassword';
import { Message } from 'core/ui-next/modal';

export async function confirmPasswordForClocking(user: ClockingUserDTO): Promise<boolean> {

	if (!user.CanClockingWithPassword) {
		await Message.show(Res.Msg.MSG_CANNOT_REGISTER_CLOCKING_WITH_PASSWORD());
		return false;
	}

	if (!user.RequiresPassword)
		return true;

	const result = await getPassword(user, { title: Res.Web.GET_PASSWORD_FOR_CLOCKING(), helpTitle: Res.Web.GET_PASSWORD_FOR_CLOCKING_HELP_TITLE() });
	return result.ok;
}